module.exports = __webpack_public_path__ + "static/world-c637fe915b8305d2375356809ef8f4d4.png";